The optional given name of a person.
